<template>
  <div>
    <div class="bg-scroll bg-top bg-center bg-cover h-screen home">
      <div class="home-feature-wrapper">
        <div class="home-feature font-second">
          <p
            class="is-size-2 is-size-4-mobile home-feature-category"
            @click.stop="scrollView('teacher')"
          >
            Teacher
          </p>
          <p
            class="is-size-2 is-size-4-mobile home-feature-category"
            @click.stop="scrollView('semiticist')"
          >
            Semiticist
          </p>
          <p
            class="is-size-2 is-size-4-mobile home-feature-category"
            @click.stop="scrollView('theologian')"
          >
            Theologian
          </p>
          <div class="home-feature-button font-main">
            <button @click.stop="$router.push('/register').catch(e => e)">
                Get Started 
              <span class="icon is-small">
                <i class="fas fa-arrow-right" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div ref="teacher" class="home-feature-view ">
      <div class="columns is-fullheight feature-box">
        <div class="column has-text-centered is-12">
          <p
            class="feature-title subtitle font-second--bold is-size-4-mobile is-size-3"
          >
            I've been a teacher for more than two decades.
          </p>
          <p
            class="feature-content container content font-main section is-size-4 is-size-6-mobile"
          >
            For the last 22 years, I taught at the Southern Baptist Seminary in
            Louisville, Kentucky, where I taught Old Testament, especially,
            Hebrew and Aramaic. I am the author of Introduction to Biblical
            Hebrew and Introduction to Biblical Hebrew Syntax. Before coming to
            Southern Seminary, I taught Old and New Testament at Mid-Continent
            College in Mayfield, Kentucky for two years. My beliefs and
            teachings are consistent with The Baptist Confession of Faith 1689.
          </p>
        </div>
      </div>
    </div>
    <div ref="semiticist" class="home-feature-view ">
      <div class="columns is-fullheight feature-box">
        <div class="column has-text-centered is-12">
          <p
            class="feature-title subtitle font-second--bold is-size-3 is-size-4-mobile"
          >
            Biblical languages are my specialty.
          </p>
          <p
            class="feature-content container content font-main section is-size-4 is-size-6-mobile"
          >
            Studying the Bible, the primary source of the Christian faith, is
            essential to faith and obedience to God. Hebrew, Aramaic, and Greek,
            the original languages of God’s word, and accurate English
            translations of these languages are the tools of Bible study.
            Understanding the biblical languages and studying English
            translations are crucial for interpreting God’s word. The study of
            these languages requires much time and effort, but the reward is
            great.
          </p>
        </div>
      </div>
    </div>
    <div ref="theologian" class="home-feature-view ">
      <div class="columns is-fullheight feature-box">
        <div class="column has-text-centered is-12">
          <p
            class="feature-title subtitle font-second--bold is-size-3 is-size-4-mobile"
          >
            Understanding the Scriptures and its teachings is my primary goal
          </p>
          <p
            class="feature-content container content font-main section is-size-4 is-size-6-mobile"
          >
            Learning biblical languages is not an end in itself. They are the
            means to understand the Bible, in specific passages and in its
            overall message (or theology). By studying the Bible in its original
            languages and through accurate translations, we learn what we are to
            believe concerning God and what duty God requires of us.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fuller from '@/assets/Fuller_main.jpg'
export default {
  name: 'Home',
  data() {
    return {
      Fuller,
    }
  },
  methods: {
    scrollView(element) {
      this.$refs[element].scrollIntoView({ behavior: 'smooth' })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_vars.scss';
@import '@/assets/css/_colors.scss';
.home {
  background-image: $mask, url('../assets/Fuller_main.jpg');
  & > .home-feature-wrapper {
    height: 100%;
    position: relative;
    & > .home-feature {
      position: absolute;
      top: 40%;
      right: 0;
      height: 50%;
      width: 45%;
      color: white;
      & > .home-feature-category {
        position: relative;
        cursor: pointer;
        &:before {
          content: '';
          position: absolute;
          bottom: 6px;
          left: 0;
          width: 0em;
          height: 1px;
          background-color: white;
          transition: width 0.15s ease-in-out;
        }
        &:hover:before {
          width: 30%;
        }
      }
      & > .home-feature-button {
        & > button {
          outline: none;
          /* border: 1px solid #9f9eb0; */
          border: 1px solid white;
          width: 10em;
          padding: 6px 3px;
          text-align: center;
          margin-top: 2em;
          &:hover {
            /* background-color: #9f9eb0; */
            background-color: white;
            color: black;
          }
        }
      }
    }
  }
}
.home-feature-view {
  padding: 0 5%;
  padding-top: 10%;
  padding-bottom: 10%;
  border-bottom: rgba(0, 0, 0, 0.4);
  &:nth-child(odd) {
    background-color: rgba(#34324d, 0.9);
    & > .feature-box {
      & > div > .feature-title {
        color: white;
      }
      & > div > .feature-content {
        color: white;
      }
    }
  }
  & > .feature-box {
    & > div > .feature-title {
      /* font-size: 2.25em; */
      color: #34324d;
    }
    & > div > .feature-content {
      /* font-size: 1.25em; */
      color: #34324d;
    }
  }
}
</style>
